import React from 'react'
import { cn } from '@/lib/utils'

interface RadioButtonProps {
  id: string
  name: string
  value: string
  checked: boolean
  onChange: (value: string) => void
  label: string
  disabled?: boolean
  className?: string
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  className
}) => {
  return (
    <div className={cn("flex items-center space-x-3", className)}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        className="w-4 h-4 text-primary bg-gray-100 border-gray-300 focus:ring-primary focus:ring-2"
      />
      <label
        htmlFor={id}
        className={cn(
          "text-sm font-medium cursor-pointer",
          disabled ? "text-gray-400 cursor-not-allowed" : "text-text-primary"
        )}
      >
        {label}
      </label>
    </div>
  )
}

interface RadioGroupProps {
  name: string
  value: string
  onChange: (value: string) => void
  options: Array<{
    value: string
    label: string
  }>
  disabled?: boolean
  className?: string
  error?: string
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  value,
  onChange,
  options,
  disabled = false,
  className,
  error
}) => {
  return (
    <div className={cn("space-y-3", className)}>
      {options.map((option) => (
        <RadioButton
          key={option.value}
          id={`${name}-${option.value}`}
          name={name}
          value={option.value}
          checked={value === option.value}
          onChange={onChange}
          label={option.label}
          disabled={disabled}
        />
      ))}
      {error && (
        <p className="text-sm text-error">{error}</p>
      )}
    </div>
  )
}
